import DesktopNavigation from "./DesktopNavigation";
import MobileNavigation from "./MobileNavigation";
import { useMe } from "../../../../hooks/queries/useMe";
import GuestLoginMenu from "./GuestLoginMenu";
import UserAvatarMenu from "./UserAvatarMenu";
import { prependCdnResourcesUrl } from "@/utils/network";

export default function Header() {
  const { data: user } = useMe();
  
  return (
    <header className="relative z-50 bg-white">
      <nav className="relative flex items-center justify-between gap-4 px-4 sm:px-5 py-2 xl:py-5 sm:min-h-[86px] max-w-page mx-auto">
        {/* Logo */}
        <div className="flex lg:flex-1">
          <a href="/">
            <img
              src={prependCdnResourcesUrl("/images/global/networx-logo-v2.svg")}
              alt="Networx"
              className="h-7 xl:h-8 w-auto"
            />
          </a>
        </div>

        {/* Desktop Navigation - Centered */}
        <div className="!hidden lg:!flex lg:flex-1 mx-auto w-full">
          <DesktopNavigation />
        </div>

        {/* Desktop CTA Buttons - Right side */}
        <div className="!hidden lg:!flex lg:flex-1 lg:items-center lg:justify-end lg:gap-4">
          {user?.isLoggedIn ? (
            <UserAvatarMenu user={user} />
          ) : (
            <GuestLoginMenu user={user} />
          )}
        </div>

        {/* Mobile Navigation - Only on mobile */}
        <div className="!flex lg:!hidden">
          <MobileNavigation user={user} />
        </div>
      </nav>
    </header>
  );
}
